import React, { Component } from 'react';
import styles from './ViewEntity.module.css';
import Comment from '../../components/Comment';
import PlayerContainer from '../../components/PlayerContainer';
import Divider from '../../components/Divider';
import { connect } from 'react-redux';
import { getModel, saveModel, fetchModels } from '../../modules/models';
import {
  getMaterial,
  saveMaterial,
  fetchMaterials,
} from '../../modules/materials';
import { getScene, saveScene } from '../../modules/scenes';
import { fetchProducts } from '../../modules/productFamily';
import {
  initializePlayer,
  takeSnapshot,
  enterVray,
  exitVray,
  applyConfigs,
  changeModel,
  getStreamingError,
  savePublished,
  setStreamingMode,
  getStreamingMode,
  isStreaming,
  moveModel,
  rotateModel,
  cameraOperation,
} from '../../modules/player';
import PropTypes from 'prop-types';
import { createJob } from '../../modules/jobs';
import { getUser, getOrganization } from '../../modules/users';
import {
  createComment,
  fetchComments,
  getComments,
} from '../../modules/comments';
import { setView } from '../../modules/explorer';
import ReactSelect from 'react-select';
import Button from '../../components/Button';

class ViewEntity extends Component {
  state = {
    item: null,
    claraUuid: null,
    asset: null,
    assignee: null,
    pipeline: null,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  getItem = async (catogary, id) => {
    const { getModel, getMaterial, getScene } = this.props;
    let item = null;
    if (catogary === 'models') {
      item = await getModel(id);
    } else if (catogary === 'materials') {
      item = await getMaterial(id);
    } else if (catogary === 'scenes') {
      item = await getScene(id);
    }
    return item;
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  gotoEditPage = e => {
    const { router } = this.context;
    const path = router.route.match.url;
    router.history.push(`${path}/edit`);
  };

  async componentDidMount() {
    const { router } = this.context;
    const { id } = router.route.match.params;
    const { catogary, fetchComments, setView } = this.props;
    setView({ page: 'viewpage', catogary, activeLabel: 'view' });
    await fetchComments(catogary, id);
    const item = await this.getItem(catogary, id);
    this.setState({ item });
  }

  renderOptions = () => {
    const { user } = this.props;
    const { item } = this.state;
    const username = user && user.username;
    const pipeline = {
      New: 0,
      'In Progress': 1,
      'Ready for Review': 2,
      'Revision Required': 3,
      Approved: 4,
    };
    const isAssignee = item.assignee === username;
    const isReviewer =
      pipeline[item.pipeline] >= 2 && item.reviewers.indexOf(username) !== -1;

    const hasAccess = isAssignee || isReviewer;
    const options = isAssignee
      ? [
          { label: 'In Progress', value: 'In Progress' },
          { label: 'Ready for Review', value: 'Ready for Review' },
        ]
      : isReviewer
      ? [
          { label: 'Revision Required', value: 'Revision Required' },
          { label: 'Approved', value: 'Approved' },
        ]
      : [];
    return { hasAccess, options };
  };

  componentWillUnmount() {
    const { setView } = this.props;
    setView(null);
  }

  updateModel = async type => {
    const value = this.state[type];
    if (!value) return;
    const { saveModel, catogary } = this.props;
    const { item } = this.state;
    if (catogary === 'models') {
      const result = await saveModel(item._id, { [type]: value });
      if (result.status === 'ok') {
        this.setState({ item: result.model });
      }
    }
  };

  render() {
    const {
      catogary,
      initializePlayer,
      user,
      organiztion,
      comments,
      createComment,
      takeSnapshot,
      enterVray,
      exitVray,
      applyConfigs,
      changeModel,
      fetchProducts,
      fetchModels,
      fetchMaterials,
      streamingError,
      savePublished,
      createJob,
      setStreamingMode,
      streamingMode,
      streaming,
      moveModel,
      rotateModel,
      cameraOperation,
    } = this.props;
    const { item, assignee, pipeline } = this.state;
    if (!item) return null;
    const { hasAccess, options } = this.renderOptions();
    const metadata = item.metadata || {};
    const asset =
      item.assets && item.assets.length > 0
        ? item.assets.slice(-1).pop()
        : null;
    return (
      <div className={styles.newModel}>
        <div className={styles.header}>
          {item.friendlyName || `Untitled Model`}
        </div>
        <Divider />
        <div className={styles.metadataField}>
          <div className={styles.metadataContainer}>
            {metadata &&
              Object.keys(metadata).map(k => (
                <div key={k} className={styles.metaContainer}>
                  <label className={styles.metadataKey}>{k + ':'}</label>
                  <span className={styles.metadataValue}>
                    {/http/.test(metadata[k]) ? (
                      <a href={metadata[k]} target="_blank">
                        {k}
                      </a>
                    ) : typeof metadata[k] === 'boolean' ? (
                      metadata[k] ? (
                        'Yes'
                      ) : (
                        'No'
                      )
                    ) : (
                      metadata[k]
                    )}
                  </span>
                </div>
              ))}
            <div key="tags" className={styles.metaContainer}>
              <label className={styles.metadataKey}>tags</label>:{' '}
              <span className={styles.metadataValue}>
                {item.tags.join(',')}
              </span>
            </div>
            {asset && asset.materials && (
              <div key="materials" className={styles.metaContainer}>
                <label className={styles.metadataKey}>materials</label>:{' '}
                <span className={styles.materialList}>
                  {asset.materials.join('\n')}
                </span>
              </div>
            )}
            <p onClick={this.gotoEditPage} className={styles.editModel}>
              Edit {catogary.slice(0, catogary.length - 1)} information
            </p>
          </div>
          <Divider />
          <div className={styles.assignReview}>
            <div className={styles.reviewStatusContainer}>
              <div className={styles.metadataKey}>Currently Assigned to </div>
              <div className={styles.reviewContainer}>
                <ReactSelect
                  className={styles.statuDropdown}
                  placeholder={item.assignee}
                  value={assignee || item.assignee}
                  options={organiztion.members.map(member => ({
                    label: member.username,
                    value: member.username,
                  }))}
                  onChange={data =>
                    this.setState({ assignee: data && data.value })
                  }
                />
                <Button
                  text="Update"
                  height={37}
                  style={{ marginTop: 10, marginLeft: 10 }}
                  onClick={e => this.updateModel('assignee')}
                />
              </div>
            </div>
            <div className={styles.reviewStatusContainer}>
              <div className={styles.metadataKey}> Status </div>
              <div className={styles.reviewContainer}>
                <ReactSelect
                  className={styles.statuDropdown}
                  placeholder={item.pipeline}
                  value={pipeline || item.pipeline}
                  disabled={!hasAccess}
                  options={options}
                  onChange={data =>
                    this.setState({ pipeline: data && data.value })
                  }
                />
                <Button
                  text="Update"
                  height={37}
                  style={{ marginTop: 10, marginLeft: 10 }}
                  onClick={e => this.updateModel('pipeline')}
                />
              </div>
            </div>
          </div>
        </div>
        <PlayerContainer
          item={item}
          enterVray={enterVray}
          exitVray={exitVray}
          catogary={catogary}
          fetchMaterials={fetchMaterials}
          initializePlayer={initializePlayer}
          takeSnapshot={takeSnapshot}
          applyConfigs={applyConfigs}
          changeModel={changeModel}
          fetchProducts={fetchProducts}
          fetchModels={fetchModels}
          streamingError={streamingError}
          savePublished={savePublished}
          createJob={createJob}
          setStreamingMode={setStreamingMode}
          streamingMode={streamingMode}
          streaming={streaming}
          moveModel={moveModel}
          rotateModel={rotateModel}
          cameraOperation={cameraOperation}
        />
        <div className={styles.commentContainer}>
          <Comment
            user={user}
            createComment={createComment}
            catogary={catogary}
            comments={comments[item._id] || []}
          />
        </div>
      </div>
    );
  }
}

const ViewEntityPage = catogary =>
  connect(
    state => ({
      catogary: catogary,
      user: getUser(state),
      organiztion: getOrganization(state),
      comments: getComments(state, catogary),
      streamingError: getStreamingError(state),
      streamingMode: getStreamingMode(state),
      streaming: isStreaming(state),
    }),
    {
      initializePlayer,
      getModel,
      getMaterial,
      getScene,
      saveScene,
      saveModel,
      saveMaterial,
      createComment,
      fetchComments,
      setView,
      takeSnapshot,
      enterVray,
      exitVray,
      applyConfigs,
      changeModel,
      fetchProducts,
      fetchModels,
      fetchMaterials,
      savePublished,
      createJob,
      setStreamingMode,
      moveModel,
      rotateModel,
      cameraOperation,
    }
  )(ViewEntity);

export default ViewEntityPage;



// WEBPACK FOOTER //
// ./src/containers/ViewEntity/index.js